var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTeamsManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.261,
    height: 130.047,
    viewBox: "0 0 141.261 130.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gestione_squadre",
    "data-name": "gestione squadre",
    transform: "translate(-451.749 -3285.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37548",
    "data-name": "Tracciato 37548",
    d: "M607.077,3360.727a50.095,50.095,0,0,1,0,34.443l-9.4-3.431a41.024,41.024,0,0,1-7.032,12.11l7.718,6.484a50.592,50.592,0,0,1-29.846,17.187l-1.749-9.879a39.989,39.989,0,0,1-14,0l-1.715,9.879a51.307,51.307,0,0,1-16.467-5.969,50.661,50.661,0,0,1-13.379-11.218l7.719-6.484a40.3,40.3,0,0,1-7.033-12.11l-9.4,3.431a49.565,49.565,0,0,1,0-34.443l9.4,3.43a40.124,40.124,0,0,1,7.033-12.076l-7.719-6.484a49.4,49.4,0,0,1,13.379-11.218,50.58,50.58,0,0,1,16.467-6l1.715,9.915a39.989,39.989,0,0,1,14,0l1.749-9.915a50.474,50.474,0,0,1,29.846,17.222l-7.718,6.45a41.024,41.024,0,0,1,7.032,12.11Zm-22.128,17.221a25.18,25.18,0,1,0-25.18,25.181A25.153,25.153,0,0,0,584.949,3377.948Z",
    transform: "translate(-19.62 -14.302)",
    fill: "none",
    stroke: "#b4b4b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_159879",
    "data-name": "Raggruppa 159879",
    transform: "translate(454.255 3288.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_349",
    "data-name": "Tracciato 349",
    d: "M480.074,3350.364l-2.384,6.653a36.153,36.153,0,0,1-10.714-6.133,35.713,35.713,0,0,1-7.936-9.405l6.143-3.57a28.393,28.393,0,0,1-3.422-9.259l-6.941,1.247a34.942,34.942,0,0,1,4.159-23.917l6.113,3.517a28.275,28.275,0,0,1,6.341-7.536l-4.577-5.435a34.823,34.823,0,0,1,10.645-6.174,35.645,35.645,0,0,1,12.16-2.181l-.006,7.092a28.18,28.18,0,0,1,9.719,1.69l2.412-6.673a35.574,35.574,0,0,1,18.646,15.562l-6.139,3.547",
    transform: "translate(-454.255 -3288.171)",
    fill: "none",
    stroke: "#b4b4b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeamsManagement);
export default __webpack_public_path__ + "static/media/ic_teams_management.dbd7394286ddd2abeb8f99ceac163fbe.svg";
export { ForwardRef as ReactComponent };